<template>
  <div
    data-v-6c8d75ed=""
    id="modalDepositTrue"
    tabindex="-1"
    aria-labelledby="modalLabel-auto"
    data-modal="modal"
    ref="bank"
    class="modal fade "
    aria-modal="true"
    role="dialog"
  >
    <div
      data-v-6c8d75ed=""
      class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
    >
      <div data-v-6c8d75ed="" class="modal-content">
        <div data-v-6c8d75ed="" class="modal-header">
          <button
            data-v-6c8d75ed=""
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            class="btn-close"
          >
            <svg
              data-v-6c8d75ed=""
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="circle-xmark"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
              class="fa-xl svg-inline--fa fa-circle-xmark"
            >
              <path
                data-v-6c8d75ed=""
                fill="currentColor"
                d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM175 208.1L222.1 255.1L175 303C165.7 312.4 165.7 327.6 175 336.1C184.4 346.3 199.6 346.3 208.1 336.1L255.1 289.9L303 336.1C312.4 346.3 327.6 346.3 336.1 336.1C346.3 327.6 346.3 312.4 336.1 303L289.9 255.1L336.1 208.1C346.3 199.6 346.3 184.4 336.1 175C327.6 165.7 312.4 165.7 303 175L255.1 222.1L208.1 175C199.6 165.7 184.4 165.7 175 175C165.7 184.4 165.7 199.6 175 208.1V208.1z"
                class=""
              ></path>
            </svg>
          </button>
        </div>
        <div data-v-6c8d75ed="" class="modal-body">
          <div
            data-v-6c8d75ed=""
            class="header-label"
            style="background: linear-gradient(rgb(249, 220, 78) 0%, rgb(118, 115, 19) 100%);"
          >
            <span data-v-6c8d75ed="" style="color: rgb(255, 255, 255);"
              >ฝากเงินออโต้</span
            >
          </div>
          <div data-v-37d31560="" data-v-6c8d75ed="" id="DepositAuto">
            <div
              data-v-10dfe038=""
              data-v-37d31560=""
              v-for="(item, index) in bank"
              :key="`ch-${index}`"
              id="show-bank"
              style="border: 1px solid rgb(249, 220, 78);"
            >
              <p data-v-10dfe038="" class="main-label">ฝากเงินเข้าบัญชีนี้</p>
              <div data-v-10dfe038="">
                <div data-v-10dfe038="" class="bank-detail">
                  <img
                    :style="{
                      'background-color': getBankColorwithCode(item.BankCode),
                      padding:
                        item.BankCode == 'co.th.truemoney.wallet' ? '' : '10px',
                    }"
                    v-bind:src="getBankImgwithCode(item.BankCode)"
                    alt=""
                  />
                  <div data-v-10dfe038="" class="bank-detail--name">
                    <span data-v-10dfe038="" class="bank-code">{{
                      getBankName(item.BankCode)
                    }}</span>
                    <span data-v-10dfe038="" class="bank-name">{{
                      item.fullName
                    }}</span>
                  </div>
                </div>
                <div data-v-10dfe038="" class="bank-detail--number">
                  <span data-v-10dfe038="" class="number-label">เลขบัญชี</span>
                  <span data-v-10dfe038="" class="bank-number"
                    >{{ item.BankAccount }}
                    <a
                      data-v-10dfe038=""
                      @click="copyBack(item.BankAccount)"
                      href="javascript:void(0)"
                      ><span data-v-10dfe038="" class="badge bg-danger"
                        >คัดลอกบัญชี</span
                      ></a
                    ></span
                  >
                </div>
              </div>
            </div>
            <div data-v-37d31560="" id="linebot">
              <a
                v-bind:href="`https://line.me/R/ti/p/${getLineId}`"
                class="btn linebot text-white p-2"
                ><img src="/images/line.png" alt="" width="20" /> ไลน์บอท
                แจ้งเตือนยอดฝาก/ถอน
              </a>
            </div>
            <!---->
            <div data-v-37d31560="" class="mt-3 text-white">
              <!---->
              <div id="c-wrap-bonus-list">
                <div
                  class="swiper-container swiper swiper-container-initialized swiper-container-horizontal swiper-container-pointer-events"
                >
                  <div
                    class="swiper-wrapper"
                    id="swiper-wrapper-8104ba109322645f33"
                    aria-live="off"
                    style="transform: translate3d(0px, 0px, 0px);"
                  >
                    <div
                      class="swiper-slide swiper-slide-active"
                      role="group"
                      aria-label="1 / 1"
                      style="width: 441px; margin-right: 30px;"
                    >
                      <img
                        src="https://rocketwinoffice.s3.ap-southeast-1.amazonaws.com/OSMVER/PROMOTION/โปร.jpg"
                      />
                    </div>
                  </div>
                  <span
                    class="swiper-notification"
                    aria-live="assertive"
                    aria-atomic="true"
                  ></span>
                </div>
                <!---->
              </div>
              <!---->
            </div>
            <div data-v-37d31560="" class="background-description mt-3">
              <div data-v-37d31560="" class="my-3 mx-2">
                <h5><strong>กฎกติกาการฝากเงิน</strong></h5>
                <h5><strong>1. ฝากเงินไม่มีขั้นต่ำ</strong></h5>
                <h5>
                  <strong>2. เช็คเลขบัญชีธนาคารก่อนทำรายการฝากทุกครั้ง</strong>
                </h5>
                <h5>
                  <strong
                    >3.
                    สมาชิกต้องโอนเงินผ่านทางแอพพลิเคชั่นของธนาคารเท่านั้น</strong
                  >
                </h5>
                <h5>
                  <strong
                    >4. การโอนเงินสมาชิกต้องใช้บัญชีเดียวกันกับที่ผูกไว้เท่านั้น
                    ไม่เช่นนั้นเงินจะไม่เข้าระบบ</strong
                  >
                </h5>
                <h5>
                  <strong
                    >5. TRUNOVER คือ
                    ยอดเดิมพันที่มีผลได้และเสียทั้งหมดแต่ละตามารวมกัน
                    ในกรณีที่การเดิมพันมีการยกเลิกหรือผลออกมาเสมอ
                    แล้วทางระบบคืนเงินนั้นจะไม่นำมาคิดยอด TRUNOVER</strong
                  >
                </h5>
                <h5>
                  <strong
                    >6.
                    กรณีทำผิดกฏข้อใดข้อหนึ่งทางเราไม่รับผิดชอบให้ทุกกรณี</strong
                  >
                </h5>
              </div>
            </div>
          </div>
        </div>
        <!---->
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { UserInfoMixins } from '@/mixins/UserInfo.js'
import { BankMixins } from '@/mixins/BankService.js'
import moment from 'moment'

export default {
  name: 'DepositFormTrue',
  mixins: [BankMixins, UserInfoMixins],
  props: {
    bank: Array,
  },
  props: ['bank'],

  data() {
    return {
      listitem: this.bank,
      // bankList: this.bankList,
    }
  },
  computed: {
    ...mapGetters([
      'getError',
      'getLoading',
      'getLineId',
      'getGameList',
      'getPromotion',
      'getPrefix',
    ]),
  },
  methods: {
    async copyBack(item) {
      this.$copyText(item, this.$refs.bank)
      this.$swal.fire('คัดลอกแล้ว', '', 'success')
    },
  },
  async mounted() {},
}
</script>
<style scoped>
.modal-dialog .modal-content[data-v-6c8d75ed] {
  background-color: #151515;
  border-radius: 10px;
  box-shadow: 0 0 5px #000;
}
.modal-dialog .modal-content .modal-body .header-label[data-v-6c8d75ed] {
  color: #fff;
  font-weight: 700;
  font-size: 18px;
  text-align: center;
  padding: 0.8rem 0.5rem;
  margin-top: 0.3rem;
  margin-bottom: 0.5rem;
  background: linear-gradient(180deg, #a44bc9, #6200b5);
  border-radius: 4px;
}
.modal-dialog .modal-content .modal-header .btn-close[data-v-6c8d75ed] {
  color: #fff;
  background: none;
  width: auto;
  height: auto;
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5)
    calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(var(--bs-modal-header-padding-y) * -0.5)
    calc(var(--bs-modal-header-padding-x) * -0.5)
    calc(var(--bs-modal-header-padding-y) * -0.5) auto;
}
.modal-dialog .modal-content .modal-header[data-v-6c8d75ed] {
  color: #fff;
  border-bottom: none;
  padding: 0.225rem 0.5rem;
}
.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid
    var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-dialog .modal-content .modal-body[data-v-6c8d75ed] {
  padding-top: 0;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}
.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

#cashback .blog-cashback[data-v-4ad267e1] {
  padding: 1rem 1rem 0;
  color: #fff;
  background: rgba(0, 0, 0, 0.8);
}
.blog-data-amount h2[data-v-4ad267e1] {
  color: #f7ac03;
  font-weight: 600;
  font-size: 2.5rem;
  margin: 0;
}
table,
td,
th {
  padding: 5px;
}

table {
  width: 100%;
  border-collapse: collapse;
}
td {
  padding: 5px;
}
#comp-list-bonus-other {
  display: grid;
  gap: 7px;
  grid-template-areas: '. . ';
}

#content-table-resx {
  background: linear-gradient(
    rgb(249, 220, 78) 0%,
    rgb(118, 115, 19) 100%
  ) !important;
}

#deposit-menu {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 10px 10px;
  justify-content: center;
}
#deposit-menu .deposit-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  font-weight: 700;
  font-size: 18px;
  text-decoration: none;
  padding: 1rem;
  margin: 0.5rem;
  width: 200px;
  background: linear-gradient(180deg, #a44bc9, #6200b5);
  box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
  border: 2px solid #aec0ce;
  border-radius: 4px;
}

#deposit-menu .deposit-item img {
  width: 100%;
  max-width: 40px;
}

#show-bank {
  color: #fff;
  padding: 1rem;
  border-width: 2px;
  border-style: solid;
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.8);
  box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
}
.bank-detail--number > .bank-number {
  color: #f7ac03;
  font-weight: 700;
  font-size: 16px;
}
.main-label,
.number-label {
  font-weight: 600;
  font-size: 1rem;
  margin: 0.275rem 0 0.325rem;
}
.bank-detail--name {
  display: flex;
  flex-direction: column;
}
.bank-detail > img {
  width: 100%;
  max-width: 64px;
  margin: 0 15px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/form/DepositFormTrue.vue